import {styled, clsx} from 'external/material'
import {Link} from 'external/react'

import useTranslations from 'hooks/translations'
import { centerVertically } from 'utils/style'

import {viewerGuard, subdomainLink} from 'utils/url'
import {logLessonAccess} from 'utils/lesson'
import useSession from 'hooks/session'
import { PreviewIcon } from 'resources/icons'
import useProfile from 'hooks/profile'


const StyledDashboardActivityItemLink = styled('div')(dashboardActivityItemLinkStyles)

export default function DashboardActivityItemLink(props) {

    const {navigation} = useSession()
    const {language} = useTranslations()
    const {hasEpl, type, clique} = props
    const {locked} = useProfile()

    const link = !locked && !hasEpl && type != 'comment' && navigation.section.link({
        pageName: 'my-courses',
        groupId: clique,
        section: type == 'assignment'
            ? 'assessment'
            : type == 'uploaded'
                ? 'lesson'
                : 'homework'
        })
    
    return(<StyledDashboardActivityItemLink className={clsx(type, props.className)}>
            {(!locked && hasEpl) && <a
                    className='link'
                    onClick={logLessonAccess('online', {...props, id: props.lesson})}
                      {...viewerGuard({
                        target: "_blank",
                        href: subdomainLink('preview', '#',  language, 'lesson', props.lesson)
                    })}
                >
                   <div className="icon-container">
                        <PreviewIcon fill="#2c75bd" width={20} />
                    </div>
                </a>
            }
            {(!hasEpl || locked) && <Link className="link" to={link}>
                   <div className="icon-container">
                        <PreviewIcon fill="#2c75bd" width={20} />
                    </div>
                </Link>}
        </StyledDashboardActivityItemLink>
   )
}

function dashboardActivityItemLinkStyles(){
    return {
        ...centerVertically,
        padding: 0,
        "& > .link": {
            ...centerVertically,
            borderRadius: 100,
            width: 40,
            height: 40,
            '& .icon-container': {
                display: 'flex',
                justifyContent: 'center'
            },
            cursor: 'pointer',
            backgroundColor: '#edeff4',
            '& .link': {
                textDecoration: 'none',
                color: '#fff',
            },
            '&.comment': {
                backgroundColor: '#848b92',
                cursor: 'default'

            }
        }
    }
}